import React, { useState } from "react";
import {
  Heading,
  TabNavigation,
  TabNavigationItem
} from "@walmart-web/livingdesign-components";
import { createUseStyles } from "react-jss";
import BudgetList from "./Budget/BudgetList";
import { useLocation } from "react-router-dom";
import Invoice from "./Invoice/FinancialInvoiceList";
import { useSelector } from "react-redux";
import { getTabList } from "../../helpers/utils";
import { TAB_LABEL } from "../../constants/tabLabel";
import JobStatusList from "../JobStatus/JobStatusList";
import ActionPopover from "../../components/Table/ActionPopover/ActionPopover";
import { useHistory } from 'react-router-dom';
import { Plus } from "@walmart-web/livingdesign-icons";
import UploadInvoice from "./Invoice/UploadInvoice/UploadInvoice";
import FinancialStyles from "./Invoice/Financial.styles";

/**
 * FinancialList component - It will use for displaying the overview of financial
 * alongside with Budgets, Invoices and workflows
 *
 */
const Financial = () => {
  const classes = FinancialStyles();
  const financialAccessibility = useSelector((state) => state?.accessibility?.applicationAccess?.financial);
  const { listOfTabs, tabIndexMap } = getTabList(financialAccessibility);
  const {state: {currentFinancialTab : currentTab} = {}} = useLocation();
  const [isCurrent, setIsCurrent] = useState(currentTab || tabIndexMap[listOfTabs[0]]);
  const [fromUploadScreen, setFromUploadScreen] = useState(false);
  const [listOfTabsFeature, setListOfTabsFeature] = useState(listOfTabs);
  const history = useHistory();
  const createActionItems = [
    financialAccessibility?.budget?.addNew && {
      "actionId": 0,
      "label": "Budget",
      "isAboveDivider": true,
    },
    financialAccessibility?.invoice?.addNew && {
      "actionId": 1,
      "label": "Invoice",
      "isAboveDivider": true,
    },
    financialAccessibility?.invoice?.addNew && {
      "actionId": 2,
      "label": "LEDES Invoice(s)",
      "isAboveDivider": true,
    },
  ]

  const handleChangeStatus = (id, tableMeta) => {
    switch(id) {
      case 0:
        history.push("/budget/0/view", { fromMatter: false, currentFinancialTab: isCurrent });
        break;
      case 1:
        history.push("/invoice/0/view", {currentFinancialTab: isCurrent});
        break;
      case 2:
        setIsCurrent(3)
        break;
      default:
        history.push("/invoice/0/view", {currentFinancialTab: isCurrent});
        break;
      
    }
  }
  const tabChangeFromUploadScreen = (value, callback) => {
    setFromUploadScreen(value);
    if (callback) {
      callback();
    }
  }

  const setIsCurrentTab = (tabIdx, withFilters) => {
    if (withFilters === true) {
      tabChangeFromUploadScreen(true, ()=> {
        setIsCurrent(tabIdx)
      });
    } else if (withFilters === false) {
      setFromUploadScreen(false);
    } else {
      setIsCurrent(tabIdx)
    }
  }

  const tabContent = () => {
    switch (isCurrent) {
      case tabIndexMap[TAB_LABEL.BUDGETS]:
        return <div data-testid="budget-wrapper"><BudgetList currentFinancialTab={isCurrent} /></div>;
      case tabIndexMap[TAB_LABEL.INVOICES]:
        return <Invoice currentFinancialTab={isCurrent} fromUploadScreen={fromUploadScreen} setIsCurrentTab={setIsCurrentTab}/>;
      case tabIndexMap[TAB_LABEL.PROCESS_STATUS]:
        return <JobStatusList/>
      case tabIndexMap[TAB_LABEL.UPLOAD_INVOICE]:
        return <UploadInvoice setIsCurrentTab={setIsCurrentTab}/>
      default:
        return null;
    }
  };

  return (
    <div className={classes.financialWrapper}>
      <div className={classes.header}>
        <Heading as="h1" size="large" className={classes.pageTitle} id="companyName">
          Financials
        </Heading>
        
        <div className={classes.create}>
          {(financialAccessibility?.budget?.addNew || financialAccessibility?.invoice?.addNew) &&
            <ActionPopover
            buttonIcon={<Plus/>}
            actionItems={createActionItems}
            onClickOption={handleChangeStatus}
            data-testid="create-btn"
            testId="create-btn"
            buttonText="Add New"
          />}
        </div>
        
      </div>
      <div className={classes.financialTabNavigation}>
        <TabNavigation>
          {listOfTabsFeature?.map((item, index) => (
            <TabNavigationItem
              data-testid={`financial-tab-${tabIndexMap[item]}`}
              id={`financial-tab-${tabIndexMap[item]}`}
              onClick={() => setIsCurrent(tabIndexMap[item])}
              isCurrent={isCurrent === tabIndexMap[item]}
              key={tabIndexMap[item]}
            >
              {item}
            </TabNavigationItem>
          ))}
        </TabNavigation>
      </div>
      <div data-testid="financial-content" id='tab-content'>
      {tabContent()}
      </div>
    </div>
  );
};

export default Financial;
